
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import IComptage from "../../../types/comptage.interface";
import preferencesService from "../../../services/preferences.service";
import comptageService from "@/services/comptage.service";
import FiltersList from "@/components/comptage/FiltersList.vue";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";
import i18n from "@/plugins/vue-i18n";
import frontService from "../../../services/front.service";

const userModule = namespace("userModule");

@Component({
  components: {FiltersList, TooltipDialog}
})
export default class SelectFilterSettingsComptage extends Vue {

  @Prop() readonly product: IComptage;
  @Prop() readonly preferenceTrigger: boolean;
  @Prop() readonly resetTrigger: boolean;
  @Prop() readonly filters;

  @userModule.State
  public user: any;

  @userModule.Action
  public getUser;

  preferencesComptage: IComptage[] = [];
  preferencesComptageSelected: IComptage[] = [];
  dialogSavePreferences = false;
  preferenceComptageModification: IComptage = {
    id: null,
    uuid: null,
    name: "",
    type: "entreprise",
    filters: {
      activity: [],
      legal: [],
      geolocation: [],
      score: {
        ceasedActivity: false,
        collectiveProcedure: false,
        certifiedRisk: true,
        veryHighRisk: true,
        highRisk: true,
        mediumRisk: true,
        lowRisk: true,
        veryLowRisk: true
      },
      effectif_bilan: {},
      ca_bilan: {},
      date_immatriculation: {},
      date_creation_bilan: {},
      effectif_groupe: {},
      ca_groupe: {},
      hasPhone: false,
      hasGroup: false,
      hasEmail: false,
      hasDirector: false,
      hasOperationalDirector: false,
    },
    files: [],
    datas: [{id: 0, key: "identity", filter: 'id', name: i18n.tc('siren'), disabled: false}],
    productId: null
  };

  headers = [];
  isLoadingData = true;
  search = '';
  deleteModal = false;
  preferenceToDelete: IComptage = {
    name: "",
    type: ""
  };
  tooltip = false;
  tooltip2 = false;

  @Watch("preferenceTrigger")
  getAllPreferences() {
    this.isLoadingData = true;
    preferencesService.getPreferencesFilters(this.user.id, ['comptage']).then((prefRes: any) => {
      this.preferencesComptage = prefRes.data.message.Items;
      this.isLoadingData = false;
    });
  }

  @Watch("resetTrigger")
  resetSelected() {
    this.preferencesComptageSelected = [];
  }

  setPreferencesComptageSelected() {
    if (this.preferencesComptageSelected.length > 0) {
      this.$emit('apply-preference', JSON.parse(JSON.stringify(this.preferencesComptageSelected[0])));
    } else {
      this.$emit('apply-preference', null);
    }
  }

  deleteItem(item: IComptage) {
    this.preferenceToDelete = item;
    this.deleteModal = true;
  }

  finalDelete() {
    this.isLoadingData = true;
    preferencesService.deletePreferenceFilter(this.preferenceToDelete.uuid, this.user.id).then(() => {
      this.preferenceToDelete = {
        name: "",
        type: ""
      };
      this.getAllPreferences();
    });
  }

  created() {
    this.headers = [
      {
        text: "Nom",
        value: "name",
        align: 'left',
        width:'21vmax'
      },
      {
        text: "Date",
        value: "date",
        align: 'center',
        width:'15vmax'
      },
      {
        text: i18n.tc('segment'),
        value: "segment",
        width:'14vmax',
        sortable: false
      },
      {text: "Actions", value: "actions", sortable: false}
    ];
    if (this.user && this.user.id) {
      this.getAllPreferences();
    } else {
      this.getUser().then(res => {
        this.getAllPreferences();
      });
    }
  }

  savePreferenceFilter() {
    this.isLoadingData = true;
    preferencesService.deletePreferenceFilter(this.preferenceComptageModification.uuid, this.user.id).then(() => {
      preferencesService.savePreferenceFilter(this.preferenceComptageModification, this.user.id, 'comptage').then(res => {
        this.$emit('save-preference', true);
        //this.$emit('refresh');
        this.getAllPreferences();
      });
    });
  }

  editItem(item) {
    this.preferenceComptageModification = JSON.parse(JSON.stringify(item));
    this.dialogSavePreferences = true;
  }

  filterAdvanced(item) {
    this.preferenceComptageModification.filters[item.code] = false;
  }

  filterFiles(item) {
    this.preferenceComptageModification.files = this.preferenceComptageModification.files.filter(f => f.uuid !== item.uuid);
  }

  removeDataToAdd(data) {
    this.preferenceComptageModification.datas = this.preferenceComptageModification.datas.filter(obj => obj.id !== data.id);
  }

  filterLegal(filterItem: any) {
    const arrayToFilter = comptageService.getChildren(filterItem).map(a => a.code);
    this.preferenceComptageModification.filters.legal = this.preferenceComptageModification.filters.legal.filter(a => arrayToFilter.indexOf(a.code) === -1);
  }

  filterActivity(filterItem: any) {
    const arrayToFilter = comptageService.getChildren(filterItem).map(a => a.code);
    this.preferenceComptageModification.filters.activity = this.preferenceComptageModification.filters.activity.filter(a => arrayToFilter.indexOf(a.code) === -1);
  }

  filterGeolocation(filterItem: any) {
    const arrayToFilter = comptageService.getChildren(filterItem).map(a => a.code);
    this.preferenceComptageModification.filters.geolocation = this.preferenceComptageModification.filters.geolocation.filter(g => arrayToFilter.indexOf(g.code) === -1);
  }

  filterScore(item: any) {
    this.preferenceComptageModification.filters.score[item.code] = false;
  }

  filterKeyNumbers(item: any) {
    this.preferenceComptageModification.filters[item.code] = {};
  }

  customSort(items, index, isDesc) {
    return frontService.customSort('date', items, index, isDesc);
  }

    customFilter(value, search, item) {
        if(this.search) {
            const finalSearch = this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            const finalValue = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            return finalValue.includes(finalSearch);
        } else {
            return false;
        }
    }

  img(value) {
    return require('@/assets/' + value);
  }

  standardization(value) {
    if(value == "entreprise")
      return "Sociétés";
    if(value == "etablissement")
      return "Établissements";
    return value;
  }

}
